module.exports = __webpack_public_path__ + "media/application/images/2023/stills_1.1.1-89d9550789cb18128bfd3700d7bc4545.png";